import IconBook from '@apollo/icons/default/IconBook.svg';
import { Button } from '@apollo/orbit';
import { Moon } from '@apollo/space-kit/illustrations/Moon';
import { Satellite1 } from '@apollo/space-kit/illustrations/Satellite1';
import React from 'react';

import { Code } from 'src/components/code/Code';

export const SubgraphInsightsUpgradeRouterCTA = () => {
  return (
    <div className="text-center sm:mx-auto">
      <Moon className="w-[180px]" />
      <>
        <h2 className="my-6 text-3xl font-semibold">Start Tracking</h2>
        <p className="text-secondary">
          It looks like your graph hasn’t reported any subgraph metrics yet.
        </p>
        <p className="text-secondary">
          Get started by upgrading to router ≥ 2.7.0 and enabling subgraph
          metrics.
        </p>
        <div className="mb-8 mt-6 flex flex-col items-center justify-center md:flex-row">
          <Button
            leftIcon={<IconBook />}
            as="a"
            // TODO(SI): DocsRouter.path('SubgraphMetrics')
            href="https://www.apollographql.com/docs/"
          >
            Go to the docs
          </Button>
        </div>
      </>
    </div>
  );
};

export const SubgraphInsightsSetupConfigCTA = () => {
  const codeStr = `telemetry:\n\tapollo:\n\t\texperimental_subgraph_metrics: true`;
  return (
    <div className="text-center sm:mx-auto">
      <Satellite1 className="w-[180px]" />
      <>
        <h2 className="my-6 text-3xl font-semibold">Set Configuration</h2>
        <p className="text-secondary">
          You can enable subgraph insights via{' '}
          <code>experimental_subgraph_metrics</code>.
        </p>

        <Code
          title="router.yaml"
          className="mt-2 text-left"
          showCopyButton={true}
          code={codeStr}
        />
        <p className="mt-4 text-secondary">
          When enabled, the router sends metrics to Studio, including <br />
          request counts, latency, and errors for each subgraph.
        </p>
        <div className="mb-8 mt-6 items-center justify-center md:flex-row">
          <Button
            leftIcon={<IconBook />}
            as="a"
            // TODO(SI): DocsRouter.path('SubgraphMetrics')
            href="https://www.apollographql.com/docs/"
          >
            Go to the docs
          </Button>
        </div>
      </>
    </div>
  );
};
